import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type ClientState = {
    currentClient: {
        id: string | undefined;
        updated: boolean;
    };
} & CommonTableState;

const initialState: ClientState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            companyDataBox: false,
            created: false,
            creator: false,
        },
        columnOrder: [
            "id",
            "extractedDocuments",
            "company.idNumber",
            "company.vatNumber",
            "period",
            "isInCorrectionMode",
            "approvalType",
            "company.phone",
            "company.email",
            "company.dataBox",
            "accountant.id",
            "useCentre",
            "useActivity",
            "useContract",
            "note",
            "valid",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
    currentClient: {
        id: undefined,
        updated: false,
    },
};

export const clientSlice = createSlice({
    name: "client",
    initialState: initialState,
    reducers: {
        updateClientTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
        setCurrentClientId: (state, action) => {
            state.currentClient = {
                id: action.payload,
                updated: true,
            };
        },
        resetCurrentClientUpdatedMark: (state) => {
            state.currentClient.updated = initialState.currentClient.updated;
        },
    },
});

// Action creators are generated for each case reducer function
export const { resetCurrentClientUpdatedMark, updateClientTableState, setCurrentClientId } = clientSlice.actions;

export default clientSlice.reducer;
